import React from 'react';
import PropTypes from 'prop-types';

// State
import { useSelector } from 'react-redux';
import { selectTaskByRecommendationId } from './store/slices/tasks';

// Components
import { Button } from '../components/buttons';
import Icon from '../components/icon/Icon';

const DEFAULT_CONTENT = {
  title: 'Nice work!',
  description:
    "Now go celebrate...preferably with something that doesn't cost you money."
};

const TaskCelebration = (props) => {
  const { recommendationId } = props;
  const task = useSelector(selectTaskByRecommendationId(recommendationId));
  const content = {
    ...DEFAULT_CONTENT,
    ...task?.celebration
  };

  return (
    <div className="flex flex-col items-center justify-center wx-12">
      <div>
        <Icon
          name="blue_check"
          data-testid="blue_checkmark_icon"
          className="mb-6 u-spacingStack4"
        />
      </div>
      <div className="text-9 mb-3 font-semibold">{content.title}</div>
      <div>
        <div className="text-4 text-center mb-6">{content.description}</div>
      </div>
      <div>
        <Button
          className="bg-blue-40 text-4 text-white font-semibold py-2 px-9 inline-block"
          onClick={props.onClick}
        >
          Continue
        </Button>
      </div>
    </div>
  );
};

TaskCelebration.propTypes = {
  onClick: PropTypes.func,
  recommendationId: PropTypes.string
};

export default TaskCelebration;
